module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('stacked-bar-chart', {
    attrs: {
      "data": _vm.data,
      "margin": _vm.margin,
      "keys": _vm.keys,
      "tip-label": _vm.tipLabel,
      "domain": _vm.domain
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Teams: Matches Vs Wins")]), _vm._v(" "), _c('p', [_vm._v("This chart visualizes the IPL teams across all seasons based on")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Total Matches Played")]), _vm._v(" "), _c('li', [_vm._v("Total Match Wins")])]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Mumbai Indian have the highest number of match wins among all other teams\n        at 80 matches.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Chennai super kings are the second most successful side in IPL behind Mumbai\n        Indians.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Both Teams have won 2 IPL titles each.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241ab626"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TeamsByWins.vue
// module id = 394
// module chunks = 1